import React, { useEffect } from 'react';
import type { PendingComponentDeletion } from './componentDeletionUtils';
import styles from './VisualEditor.module.css';

type Props = {
  pending: PendingComponentDeletion;
  onCancel: () => void;
  onConfirm: () => void;
};

export default function ComponentDeleteDialog({ pending, onCancel, onConfirm }: Props): React.ReactElement {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onCancel]);

  const { component, references } = pending;
  return (
    <div className={styles.deleteDialogBackdrop}>
      <section className={styles.deleteDialog} role="dialog" aria-modal="true" aria-labelledby="component-delete-title">
        <h2 id="component-delete-title">Delete referenced component?</h2>
        <p>
          Component <strong>{component.name}</strong> is referenced by {references.length}{' '}
          configuration item{references.length === 1 ? '' : 's'}:
        </p>
        <ul>{references.map((reference, index) => <li key={`${reference.kind}-${index}`}>{reference.label}</li>)}</ul>
        <p>Deleting it will leave broken references. Existing bindings and actions will be preserved for diagnosis.</p>
        <div className={styles.deleteDialogActions}>
          <button type="button" onClick={onCancel} autoFocus>Cancel</button>
          <button type="button" className={styles.dangerButton} onClick={onConfirm}>Delete anyway</button>
        </div>
      </section>
    </div>
  );
}
